// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import UsersForm from './UsersForm';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(UsersForm);
